module.exports = __webpack_public_path__ + "img/full6-min.4ae20899.png";